import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SplatRotateIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M7.39002 16.61L5.66002 18.34C3.98002 16.67 3.03002 14.42 3.03002 12C3.02002 7.05005 7.05002 3.02005 12 3.02005C12.35 3.02005 12.62 2.74005 12.62 2.40005C12.62 2.06005 12.34 1.78005 12 1.78005C6.36002 1.77005 1.77002 6.36005 1.77002 12C1.77002 14.76 2.85002 17.32 4.77002 19.22L3.43002 20.56C3.05002 20.94 3.32002 21.58 3.85002 21.58H7.80002C8.13002 21.58 8.40002 21.31 8.40002 20.98V17.03C8.40002 16.5 7.75002 16.23 7.38002 16.61H7.39002Z"
        fill={color}
      />
      <path
        d="M19.22 4.78004L20.56 3.44004C20.94 3.06004 20.67 2.42004 20.14 2.42004H16.19C15.86 2.42004 15.59 2.69004 15.59 3.02004V6.97004C15.59 7.50004 16.24 7.77004 16.61 7.39004L18.34 5.66004C20.02 7.33004 20.97 9.58004 20.97 12C20.97 16.95 16.94 20.97 12 20.97C11.65 20.97 11.38 21.25 11.38 21.59C11.38 21.93 11.66 22.21 12 22.21C17.64 22.21 22.22 17.62 22.22 11.99C22.22 9.23004 21.14 6.67004 19.22 4.77004V4.78004Z"
        fill={color}
      />
      <path
        d="M9.63 8H8.62C8.27758 8 8 8.27758 8 8.62V9.63C8 9.97242 8.27758 10.25 8.62 10.25H9.63C9.97242 10.25 10.25 9.97242 10.25 9.63V8.62C10.25 8.27758 9.97242 8 9.63 8Z"
        fill={color}
      />
      <path
        d="M9.63 13.75H8.62C8.27758 13.75 8 14.0276 8 14.37V15.38C8 15.7224 8.27758 16 8.62 16H9.63C9.97242 16 10.25 15.7224 10.25 15.38V14.37C10.25 14.0276 9.97242 13.75 9.63 13.75Z"
        fill={color}
      />
      <path
        d="M15.38 13.75H14.37C14.0276 13.75 13.75 14.0276 13.75 14.37V15.38C13.75 15.7224 14.0276 16 14.37 16H15.38C15.7224 16 16 15.7224 16 15.38V14.37C16 14.0276 15.7224 13.75 15.38 13.75Z"
        fill={color}
      />
      <path
        d="M15.38 8H14.37C14.0276 8 13.75 8.27758 13.75 8.62V9.63C13.75 9.97242 14.0276 10.25 14.37 10.25H15.38C15.7224 10.25 16 9.97242 16 9.63V8.62C16 8.27758 15.7224 8 15.38 8Z"
        fill={color}
      />
      <path
        d="M12.51 10.88H11.5C11.1576 10.88 10.88 11.1576 10.88 11.5V12.51C10.88 12.8524 11.1576 13.13 11.5 13.13H12.51C12.8524 13.13 13.13 12.8524 13.13 12.51V11.5C13.13 11.1576 12.8524 10.88 12.51 10.88Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SplatRotateIcon.displayName = 'SplatRotateIcon';
